const Push = require("react-router-redux").push;
const SnackbarActions = require("actions/snackbar");
const CroquisTypes = require("action-types/croquis");
const WebClient = require("utils/web-client");
const AuthActions = require("actions/auth");
const GTMCustom = require("../utils/gtm-custom");

const actions = exports;
const internals = {};

exports.loadRenderingOptionsBegin = () => {
    return {
        type: CroquisTypes.LOAD_RENDERING_OPTIONS_BEGIN
    };
};

exports.loadRenderingOptionsSuccess = renderingOptions => {
    return {
        type: CroquisTypes.LOAD_RENDERING_OPTIONS_SUCCESS,
        payload: { renderingOptions }
    };
};

exports.loadRenderingOptionsFail = error => {
    return {
        type: CroquisTypes.LOAD_RENDERING_OPTIONS_FAIL,
        payload: { error }
    };
};

exports.fetchRenderingOptions = () => {
    return dispatch => {
        dispatch(actions.loadRenderingOptionsBegin());

        const getRenderingOptions = WebClient.get("/rendering-options");

        getRenderingOptions
            .then(({ data }) => {
                dispatch(actions.loadRenderingOptionsSuccess(data));
            })
            .catch(error => {
                dispatch(actions.loadRenderingOptionsFail(error));
            });

        return getRenderingOptions;
    };
};

exports.croquisPurchaseBegin = () => {
    return {
        type: CroquisTypes.CROQUIS_PURCHASE_BEGIN
    };
};

exports.croquisPurchaseSuccess = purchased => {
    return {
        type: CroquisTypes.CROQUIS_PURCHASE_SUCCESS,
        payload: { purchased }
    };
};

exports.croquisPurchaseFail = error => {
    return {
        type: CroquisTypes.CROQUIS_PURCHASE_FAIL,
        payload: { error }
    };
};

exports.purchaseCroquis = (id, downloadPackageId) => {
    return dispatch => {
        dispatch(actions.croquisPurchaseBegin());

        const purchaseCroquis = WebClient.post(`/croquis/${id}/purchase`, {
            downloadPackageId
        });

        purchaseCroquis
            .then(({ data }) => {
                dispatch(actions.croquisPurchaseSuccess(data));
                dispatch(AuthActions.fetchUserData());
                dispatch(
                    SnackbarActions.messageSnackbar(
                        "Successfully purchased model!"
                    )
                );
            })
            .catch(error => {
                dispatch(actions.croquisPurchaseFail(error));
                dispatch(
                    SnackbarActions.messageSnackbar(
                        `Failed to purchase model! ${error.message ||
                            "Please try again."}`
                    )
                );
            });

        return purchaseCroquis;
    };
};

exports.upgradePurchaseBegin = () => {
    return {
        type: CroquisTypes.PURCHASE_UPGRADE_BEGIN
    };
};

exports.upgradePurchaseSuccess = upgradedPurchase => {
    return {
        type: CroquisTypes.PURCHASE_UPGRADE_SUCCESS,
        payload: { upgradedPurchase }
    };
};

exports.upgradePurchaseFail = error => {
    return {
        type: CroquisTypes.PURCHASE_UPGRADE_FAIL,
        payload: { error }
    };
};

exports.upgradePurchase = (purchaseId, downloadPackageId) => {
    return dispatch => {
        dispatch(actions.upgradePurchaseBegin());

        const upgradeCroquis = WebClient.post(
            `/purchases/${purchaseId}/upgrade`,
            { downloadPackageId }
        );

        upgradeCroquis
            .then(({ data }) => {
                dispatch(actions.upgradePurchaseSuccess(data));
                dispatch(AuthActions.fetchUserData());
                dispatch(
                    SnackbarActions.messageSnackbar(
                        "Successfully upgraded purchase!"
                    )
                );
            })
            .catch(error => {
                dispatch(actions.upgradePurchaseFail(error));
                dispatch(
                    SnackbarActions.messageSnackbar(
                        "Failed to upgrade purchase! Please try again."
                    )
                );
            });

        return upgradeCroquis;
    };
};

exports.croquisDeleteBegin = () => {
    return {
        type: CroquisTypes.CROQUIS_DELETE_BEGIN
    };
};

exports.croquisDeleteSuccess = id => {
    return {
        type: CroquisTypes.CROQUIS_DELETE_SUCCESS,
        payload: { id }
    };
};

exports.croquisDeleteFail = error => {
    return {
        type: CroquisTypes.CROQUIS_DELETE_FAIL,
        payload: { error }
    };
};

exports.deleteCroquis = id => {
    return dispatch => {
        dispatch(actions.croquisDeleteBegin());

        const deleteCroquis = WebClient.delete(`/croquis/${id}`);

        deleteCroquis
            .then(({ data }) => {
                dispatch(actions.croquisDeleteSuccess(id));
                dispatch(
                    SnackbarActions.messageSnackbar(
                        "Successfully deleted model!"
                    )
                );
            })
            .catch(error => {
                dispatch(actions.croquisDeleteFail(error));
                dispatch(
                    SnackbarActions.messageSnackbar(
                        "Failed to delete model! Please try again."
                    )
                );
            });

        return deleteCroquis;
    };
};

exports.loadCroquisBegin = () => {
    return {
        type: CroquisTypes.CROQUIS_LOAD_BEGIN
    };
};

exports.loadCroquisSuccess = croquis => {
    return {
        type: CroquisTypes.CROQUIS_LOAD_SUCCESS,
        payload: { croquis }
    };
};

exports.loadCroquisFail = error => {
    return {
        type: CroquisTypes.CROQUIS_LOAD_FAIL,
        payload: { error }
    };
};

exports.fetchCroquisData = () => {
    return dispatch => {
        dispatch(actions.loadCroquisBegin());

        const getCroquis = WebClient.get("/user/croquis");

        getCroquis
            .then(({ data }) => {
                dispatch(actions.loadCroquisSuccess(data));
            })
            .catch(error => {
                dispatch(actions.loadCroquisFail(error));
            });

        return getCroquis;
    };
};

exports.saveBegin = () => {
    return {
        type: CroquisTypes.CROQUIS_SAVE_BEGIN
    };
};

exports.saveSuccess = croquis => {
    return {
        type: CroquisTypes.CROQUIS_SAVE_SUCCESS,
        payload: { croquis }
    };
};

exports.saveFail = error => {
    return {
        type: CroquisTypes.CROQUIS_SAVE_FAIL,
        payload: { error }
    };
};

exports.save = croquis => {
    return dispatch => {
        if (croquis.title === "") {
            dispatch(
                SnackbarActions.messageSnackbar(
                    "Please create a name for your Body Model in Section 1: General"
                )
            );
            return;
        }

        dispatch(actions.saveBegin());

        const { title, measurements } = croquis;

        const save = WebClient.patch(`/croquis/${croquis.id}`, {
            title,
            measurements
        });

        save.then(({ data }) => {
            dispatch(actions.saveSuccess(data));
            dispatch(Push(`/body-model/${data.id}`));
            dispatch(
                SnackbarActions.messageSnackbar("Model successfully saved!")
            );
        }).catch(error => {
            dispatch(actions.saveFail(error));
            dispatch(
                SnackbarActions.messageSnackbar(
                    "Unable to save your model! Please try again!"
                )
            );
        });

        return save;
    };
};

exports.createBegin = () => {
    return {
        type: CroquisTypes.CROQUIS_CREATE_BEGIN
    };
};

exports.createSuccess = croquis => {
    return {
        type: CroquisTypes.CROQUIS_CREATE_SUCCESS,
        payload: { croquis }
    };
};

exports.createFail = error => {
    return {
        type: CroquisTypes.CROQUIS_CREATE_FAIL,
        payload: { error }
    };
};

exports.create = croquis => {
    return (dispatch, getState) => {
        if (croquis.title === "") {
            dispatch(SnackbarActions.messageSnackbar("Please enter a title"));
            return;
        }

        dispatch(actions.createBegin());

        const newCroquis = { ...croquis };

        delete newCroquis.id;

        const create = WebClient.post("/croquis", newCroquis);

        create
            .then(({ data }) => {
                dispatch(actions.createSuccess(data));
                dispatch(Push(`/body-model/${data.id}`));
                dispatch(
                    SnackbarActions.messageSnackbar(
                        "Your body model was successfully created!"
                    )
                );

                const { auth } = getState();
                GTMCustom.event("newBodyModel", auth.credentials.user.id);
            })
            .catch(error => {
                dispatch(actions.createFail(error));
                dispatch(
                    SnackbarActions.messageSnackbar(
                        "Unable to create your body model! Please try again!"
                    )
                );
            });

        return create;
    };
};

exports.fetchCroquisBegin = () => {
    return {
        type: CroquisTypes.CROQUIS_FETCH_BEGIN
    };
};

exports.fetchCroquisSuccess = croquis => {
    return {
        type: CroquisTypes.CROQUIS_FETCH_SUCCESS,
        payload: { croquis }
    };
};

exports.fetchCroquisFail = error => {
    return {
        type: CroquisTypes.CROQUIS_FETCH_FAIL,
        payload: { error }
    };
};

exports.fetchCroquis = id => {
    return dispatch => {
        dispatch(actions.fetchCroquisBegin());

        const fetch = WebClient.get(`/croquis/${id}`);

        fetch
            .then(({ data }) => {
                dispatch(actions.fetchCroquisSuccess(data));
            })
            .catch(error => {
                dispatch(actions.fetchCroquisFail(error));
                dispatch(
                    SnackbarActions.messageSnackbar(
                        "Unable load your body model! Please try again!"
                    )
                );
            });

        return fetch;
    };
};

exports.purchasedLoadBegin = () => {
    return {
        type: CroquisTypes.PURCHASED_LOAD_BEGIN
    };
};

exports.purchasedLoadSuccess = purchases => {
    return {
        type: CroquisTypes.PURCHASED_LOAD_SUCCESS,
        payload: { purchases }
    };
};

exports.purchasedLoadFail = error => {
    return {
        type: CroquisTypes.PURCHASED_LOAD_FAIL,
        payload: { error }
    };
};

exports.fetchPurchasedData = () => {
    return dispatch => {
        dispatch(actions.purchasedLoadBegin());

        const getPurchased = WebClient.get("/user/purchases");

        getPurchased
            .then(({ data }) => {
                dispatch(actions.purchasedLoadSuccess(data.purchases));
            })
            .catch(error => {
                dispatch(actions.purchasedLoadFail(error));
            });

        return getPurchased;
    };
};

exports.croquisMeasurementUpdate = (id, field, value, type) => {
    return {
        type: CroquisTypes.CROQUIS_MEASUREMENT_UPDATE,
        payload: { id, field, value, type }
    };
};

exports.croquisTitleUpdate = (id, title) => {
    return {
        type: CroquisTypes.CROQUIS_TITLE_UPDATE,
        payload: { id, title }
    };
};

exports.fetchTesterCroquisSuccess = croquis => {
    return {
        type: CroquisTypes.CROQUIS_TESTER_FETCH_SUCCESS,
        payload: { croquis }
    };
};

exports.fetchTesterData = () => {
    return dispatch => {
        internals.testerIds.map(id => {
            WebClient.get(`/croquis/${id}`)
                .then(({ data }) => {
                    dispatch(actions.fetchTesterCroquisSuccess(data));
                })
                .catch(ignoreError => {
                    dispatch(
                        SnackbarActions.messageSnackbar(
                            "Unable load tester data: " + id
                        )
                    );
                });
        });
    };
};

// qa ids
/* ids for Mechazord v.0.7.0
 * internals.testerIds = [
    150,
    151,
    152,
    153,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
    166,
    167,
    168,
    169,
    170,
    171,
    172,
    173
];*/

// ids of croquis generated w/ Mechazord v.0.8.0
internals.testerIds = [
    7302,
    7303,
    7304,
    7305,
    7306,
    7307,
    7308,
    7309,
    7310,
    7311,
    7312,
    7313,
    7314,
    7315,
    7316,
    7317,
    7318,
    7319,
    7320,
    7321,
    7322,
    7323,
    7324,
    7325,
    7326,
    7327,
    7328,
    7329
];
// bri's local ids
// internals.testerIds = [
//     142,
//     143,
//     144,
//     145,
//     146,
//     147,
//     148,
//     149,
//     150,
//     151,
//     152,
//     153,
//     154,
//     155,
//     156,
//     157,
//     158,
//     159,
//     160,
//     161,
//     162,
//     163,
//     164,
//     165
// ];



// WEBPACK FOOTER //
// ./src/actions/croquis.js